import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_ECORREGIOES, API_CRIAR_ECORREGIOES, API_EXCLUIR_ECORREGIOES, API_ATUALIZAR_ECORREGIOES } from 'store/modules/api/ecorregioes.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_ECORREGIOES.success:
      return payload.sort((a, b) => a.nome.localeCompare(b.nome))
    case API_CRIAR_ECORREGIOES.success:
      return [...state, payload].sort((a, b) => a.nome.localeCompare(b.nome))
    case API_ATUALIZAR_ECORREGIOES.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_ECORREGIOES.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const listaTerreste = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_ECORREGIOES.success:
      return filter(payload, (o) => !o.marinho &&
        o.terrestre).sort((a, b) => a.nome.localeCompare(b.nome))
    case API_CRIAR_ECORREGIOES.success:
      return [...state, payload].sort((a, b) => a.nome.localeCompare(b.nome))
    case API_ATUALIZAR_ECORREGIOES.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_ECORREGIOES.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const listaMarinho = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_ECORREGIOES.success:
      return filter(payload, (o) => o.marinho &&
      !o.terrestre).sort((a, b) => a.nome.localeCompare(b.nome))
    case API_CRIAR_ECORREGIOES.success:
      return [...state, payload].sort((a, b) => a.nome.localeCompare(b.nome))
    case API_ATUALIZAR_ECORREGIOES.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_ECORREGIOES.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isSaving = loadingReducer(false, API_CRIAR_ECORREGIOES)
const isUpdate = loadingReducer(false, API_ATUALIZAR_ECORREGIOES)
const isCarregandoLista = loadingReducer(false, API_LISTAR_ECORREGIOES)

export default combineReducers({
  lista,
  listaTerreste,
  listaMarinho,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
